import enLocale from "element-ui/lib/locale/lang/en";

export default {
  language: {
    zhName: "简体中文",
    enName: "English",
    zh: "ZH",
    en: "EN"
  },
  navbar: {
    flag: "en",
    blockHeight: "block height",
    wallet: "wallet",
    blocks: "Blocks",
    addrs: "Addresses",
    tarns: "Transactions",
    ontIds: "ONT ID List",
    top: {
      blockchain: "Blockchain",
      contracts: "Contracts",
      tokens: "Tokens",
      ontId: "ONT ID",
      apis: "APIs",
      mainNet: "MainNet",
      testNet: "TestNet",
      nodes: "Nodes",
      stake: "Stake Authorizations",
      nodeMap: "Node Map",
      blocks: "Blocks",
      txns: "Transactions",
      accounts: "Accounts",
      oep4: "OEP-4 Overview",
      oep5: "OEP-5 Overview",
      oep8: "OEP-8 Overview",
      submit: "Submit",
      statistics: "Statistics",
      tool: "Tools",
      apiDocUrl: "https://dev-docs.ont.io/#/docs-en/explorer/overview"
    }
  },
  all: {
    name: "Name",
    more: ">>",
    return: "  Back",
    block: "Block",
    hash: "Hash",
    status: "Status",
    time: "Created Time",
    height: "Height",
    byte: "byte",
    num: "Number",
    fee: "Fee",
    amount: "Amount",
    address: "Address",
    ontId: "ONT ID",
    content: "Content",
    confirmed: "Confirmed",
    failed: "Failed",
    description: "Description",
    token: "Token",
    txn: "Transaction",
    txns: "Transactions",
    pk: "Public Key",
    from: "From",
    to: "To",
    type: "Type",
    tokens: "Token List",
    contract: "Contract",
    nonce: "Nonce",
    jsonopen: "Unfold",
    jsonclose: "Fold",
    analytics: "Analytics",
    transfers: "Transferred",
    tokenid: "Token ID",
    maxMsg1: "A total of ",
    maxMsg2: " transactions found",
    maxMsg3: "(Showing the last ",
    maxMsg4: " records)",
    unknown: "Unknown",
    pending: "Pending",
    colon: ": "
  },
  ontPagination: {
    total: "A total of ",
    data: " data"
  },
  searchInput: {
    search: "SEARCH",
    placeholder:
      "ONT ID, Addresses, Transactions, Tokens, Contracts, Block Height",
    slogan: "Blockchain Explorer & Trust Verifier",
    qucik: "Quick Links:",
    oep4: "OEP-4 Tokens",
    contracts: "Contracts",
    token: "Tokens",
    ontId: "ONT ID",
    address: "Addresses",
    transaction: "Transactions",
    blockHeight: "Block Height",
    contract: "Contracts"
  },
  runStatus: {
    name: "The whole network operation status",
    RunningTime: "Whole Network Run Time:",
    CurrentHeight: "Block Height",
    BlockInterval: "Average Block Time",
    TxnCount: "Total Transactions",
    NodeCount: "Triones Nodes",
    addressCount: "Total addresses",
    second: "s",
    address: "addresses",
    ontid: "Total ONT ID",
    overview: "Overview",
    ontprice: "ONT Price ($)",
    ongprice: "ONG Price ($)",
    rank: "Market Rank",
    onttx: "ONT Transaction History In 1 Month",
    datacmc: "From CoinMarketCap",
    most: "The most wide-used Ontology official wallet"
  },
  lastData: {
    lastdata: "Latest Data",
    ontid: "ONT ID Events",
    tx: "Transactions",
    block: "Blocks"
  },
  ontIdList: {
    name: "ONT ID Events"
  },
  ontIdDetail: {
    nickname: "ONT ID Details",
    name: "ONT ID: ",
    msgName: "ONT ID Event Log",
    TxnId: "Transaction ID",
    Height: "Block height",
    TxnType: "Transaction Type",
    TxnTime: "Block Time",
    Description: "Description",
    events: "Events on this ONT ID",
    owner: "Owner",
    controller: "Controller",
    attributes: "Attributes",
    failed: "FAIL, not found."
  },
  blockList: {
    name: "Blocks",
    Height: "Height",
    TxnNum: "Txns",
    bookkeeper: "Bookkeeper",
    BlockSize: "Size",
    BlockTime: "Time",
    bookkeeperCount: "Bookkeeper"
  },
  addressList: {
    rank: "Rank",
    name: "Address",
    nickname: "Top Accounts",
    balance: " Balance",
    percent: "Percent"
  },
  addressDetail: {
    name: "Address Details",
    address: "Address: ",
    showRelatedAddress: "Show Related Address",
    hideRelatedAddress: "Hide Related Address",
    relatedEVMAddress: "Related Ontology EVM Address",
    relatedOntologyAddress: "Related Ontology Address",
    relatedAddressTip: `
About related address: <br/><br/>
1. The bytecode of the address is the same<br/>
2. The private key, the mnemonic phrase, etc., is different and not available<br/>
3. The balance of native token ONG is shared<br/>
4. Other tokens are not shared<br/><br/>
Therefore, do not send any token other than ONG to the related address because it can not be retrieved.
`,
    ontBalance: "ONT Balance",
    ongBalance: "ONG Balance",
    claimable: "Claimable ONG",
    unbound: "Unbound ONG",
    txOnAddr: "Transactions on this Address:",
    txns: "Transactions",
    oep8Assets: "OEP-8 Assets",
    oep4Assets: "OEP-4 Assets",
    oep5Assets: "OEP-5 Assets",
    orc20Assets: "ORC-20 Assets",
    orc721Assets: "ORC-721 Assets",
    orc1155Assets: "ORC-1155 Assets",
    oepOtherAssets: "Other OEP Assets"
  },
  analytics: {
    ontBalance: "ONT Balance",
    ongBalance: "ONG Balance",
    tx: "Transactions",
    token: "Token Transfers",
    transferAmount: "Transfer Amount",
    transferCount: "Transfers Amount",
    uniqueReceiver: "Unique Receivers",
    uniqueSender: "Unique Senders",
    totalUnique: "Total Unique",
    balance: "Balance",
    txnCount: "Txn Count",
    uniqueOutAddress: "Unique Outgoing Address",
    uniqueinAddress: "Unique Incoming Address",
    tokenTransfer: "Token Transfers",
    tokenContracts: "Token Contracts Count",
    contracts: "Contracts Count",
    outboundTransfers: "Outbound Transfers",
    InboundTransfers: "Inbound Transfers",
    uniqueAddresssent: "Unique Address Sent",
    uniqueAddressreceived: "Unique Address Received",
    uniqueAddress: "Unique Addresses",
    tokenTransfer: "Token Transfers",
    addressCount: "Address Count",
    nodata: "No Data"
  },
  top: {
    title: "Top Statistics",
    overview: "Overview",
    ontTx: "ONT Transactions",
    ongTx: "ONG Transactions",
    tokens: "Tokens",
    network: "Network",
    day: "24H",
    days: "3D",
    week: "7D",
    ten: "View Top 10",
    ontsender: "Top ONT Senders",
    ontreceiver: "Top ONT Receivers",
    ontcountsender: "Top ONT Txn Count Sent",
    ontcountreceiver: "Top ONT Txn Count Received",
    ongsender: "Top ONG Senders",
    ongreceiver: "Top ONG Receivers",
    ongcountsender: "Top ONG Txn Count Sent",
    ongcountreceiver: "Top ONG Txn Count Received",
    topsendertokens: "Top Tokens by Unique Senders",
    topreceivertokens: "Top Tokens by Unique Receivers",
    topaddresstokens: "Top Tokens by Total Uniques",
    toptxtokens: "Top Tokens by Txn Count",
    topsendertoken: "Top Unique Sender",
    topreceivertoken: "Top Unique Receiver",
    topaddresstoken: "Top Total Uniques",
    toptxtoken: "Top Txn Count",
    topgasaddresses: "Top Accounts by Gas Used",
    toptxaddresses: "Top Accounts by Txn Count",
    topgasaddress: "Top Gas Used",
    toptxaddress: "Top Txn Count",
    rank: "Rank",
    address: "Address",
    gasused: "Gas Used",
    txcount: "Txn Count",
    tokename: "Token Name",
    uniquesender: "Unique Senders",
    uniquereceiver: "Unique Receivers",
    uniquetotal: "Total Uniques",
    percentage: "Percentage",
    ontamount: "Total ONT",
    ongamount: "Total ONG",
    totalTx: "Total Txn",
    total: "Total"
  },
  assetName: {
    ont: "ONT",
    ong: "ONG",
    pumpkin01: "Red Pumpkin",
    pumpkin02: "Orange Pumpkin",
    pumpkin03: "Yellow Pumpkin",
    pumpkin04: "Green Pumpkin",
    pumpkin05: "Indigo Pumpkin",
    pumpkin06: "Blue Pumpkin",
    pumpkin07: "Purple Pumpkin",
    pumpkin08: "Golden Pumpkin"
  },
  blockDetail: {
    nickname: "Block Details",
    name: "Height:",
    BlockSize: "Size",
    BlockTime: "Created Time",
    keeper: "Bookkeeper",
    hash: "Hash",
    TxnNum: "Number Of Transactions In The Block:",
    Hash: "The Block Hash:",
    PrevBlock: "Previous Block:",
    LastBlock: "Last Block:",
    NextBlock: "Next Block:",
    merkle: "Transactions Root",
    Consensus: "Consensus Data",
    txOnBlock: "transactions on this block"
  },
  transList: {
    name: "Transactions",
    hash: "Hash",
    total: "Total of",
    data: "data",
    confirmed: "Confirmed",
    failed: "Failed",
    txType01: "Deploy contract transaction",
    txType02: "OEP-4 transaction",
    txType03: "OEP-5 transaction",
    txType04: "OEP-8 transaction",
    txType05: "Call contract transaction",
    txType06: "ONT-ID transaction",
    txType07: "ONT transfer transaction",
    txType08: "ONG transfer transaction",
    txType09: "ORC-20 transaction",
    txType10: "ORC-721 transaction",
    txType11: "ORC-1155 transaction"
  },
  txDetail: {
    name: "Transaction Details",
    txHash: "Hash:",
    time: "Created Time",
    type: "Type",
    deploySC: "Deploy Smart Contract",
    sc: "Invoke NeoVM Contract",
    wasmsc: "Invoke WasmVM Contract",
    evm: "Invoke EVM Contract",
    height: "Height",
    status: "Status",
    fee: "Fee",
    issuer: "Issuer OntId",
    detial: "Smart Contract Event",
    open: "Detail",
    close: "Close",
    transactionHex: "Transaction Hex",
    transactionJson: "Transaction Json",
    hexopen: "Hex",
    jasoopen: "Json",
    transfersOnTx: "Transfers on this transaction",
    noTxn: "This transaction hash is not found",
    noTxnP1:
      "If the transaction is just created, please wait for a few seconds before refreshing this page.",
    noTxnP2:
      "If the transaction is still not found after a while, please check with the sender.",
    inputData: {
      title: "Input Data",
      viewType: "View Input As",
      defaultView: "Default View",
      originalView: "Original",
      utf8View: "UTF-8",
      decode: "Decode Input Data",
      switchBack: "Switch Back",
      name: "Name",
      type: "Type",
      data: "Data"
    }
  },
  claimDetail: {
    name: "CLAIM DETAILS"
  },
  addressMsg: {
    name: "Address message",
    address: "Address",
    latestDealTime: "Latest Deal Time",
    dealNumber: "Deal Number",
    addressGenerationTime: "Address Generation Time",
    balance: "Balance"
  },
  page: {
    First: "<<",
    PreviousPage: " < ",
    NextPage: " > ",
    Last: ">>"
  },
  nodes: {
    stakeListTit: "STAKE AUTHORIZATIONS",
    rank: "Rank",
    name: "Name",
    proportion: "Reward proportion in next round Node / User",
    reward: "Reward",
    stake: "Stake",
    process: "Process",
    toNextRound: "To next round: ",
    blocks: "blocks",
    detailTit: "NODE DETAILS",
    nodeName: "Node Name: ",
    ontId: "ONT ID:",
    address: "Address:",
    rewardRate: "Reward Rate:",
    rank2: "Rank:",
    stake2: "Stake:",
    stakeOWallet: "Stake with Owallet →",
    process2: "Process:",
    ip: "IP:",
    email: "Email:",
    intro: "Introduction:",
    vision: "Vision:",
    website: "Website:",
    guideTxt:
      "To participate stake authorization, find the step-by-step guide ",
    here: "here.",
    tooltipTit:
      "This is the portion of rewards received the node has chosen to share with users who have authorized stakes with them in the next consensus round.",
    processTip: "Calculating real-time data. Please wait: "
  },
  contracts: {
    list: {
      name: "Contracts",
      tit: {
        currently: "There are currently",
        contracts: "contracts",
        checkIn: "Join"
      },
      tab: {
        hash: "Hash",
        name: "Name",
        time: "Created Time",
        txns: "Transactions",
        desc: "Description",
        logo: "Logo",
        addressCount: "Interacted Addresses",
        address: "Address"
      }
    },
    detail: {
      name: "Contract Detail Page",
      hash: "HASH",
      address: "Address",
      overview: "Contract Overview",
      desc: "Description",
      txOn: "Number Of Transactions In The Contract:",
      creator: "Creator ",
      createdTime: "Created Time",
      contractInfo: "Info",
      contact: "Contact",
      logo: "Logo",
      ontFlow: "ONT Flow: ",
      ongFlow: "ONG Flow: ",
      amount: "Total Flow: ",
      compilerType: "Compiler Type",
      compilerVersion: "Compiler Version",
      optimizationEnabled: "Optimization Enabled",
      OptimizationOn: "Yes with {runs} runs",
      OptimizationOff: "No with {runs} runs",
      otherSettings: "Other Settings",
      contractSourceCodeFile: "File {index} of {length}: ",
      settings: "Settings",
      constructorArgument: "Constructor Arguments",
      contractSourceCode: "Contract Source Code",
      virtualMachine: "Virtual Machine",
      website: "Website: ",
      email: "Email: ",
      "Official Website": "Website: ",
      otherSettingsContent: `
EVM Version: {version}<br/><br/>
License Type Settings: {license}
`,
    },
    submit: {
      headline: "Submit Contract",
      form: {
        vm_type: "Virtual Machine",
        contract_hash: "Contract Address",
        description: "Contract Description (Optional)",
        compiler_type: "Compiler Type",
        compiler_version: "Compiler Version",
        optimization: "Optimization",
        optimization_on: "Yes",
        optimization_off: "No",
        constructor_argument: "Constructor Arguments ABI-encoded (Hex String, Optional)",
        constructor_argument_short: "Constructor Arguments",
        library_list: "Contract Library Address (Optional, up to 10)",
        library_name: "Library_{index} Name",
        library_address: "Library_{index} Contract Address",
        library_format: "Library_{index}",
        misc_settings: "Misc Settings",
        runs: "Runs (Optimizer)",
        runs_short: "Runs",
        evm_version: "EVM Version",
        license_type: "License Type Settings",
        source_code: "Contract Source Code",
        abi: "Contract ABI",
        byte_code: "Contract ByteCode",
        upload_text: "Click to upload source code",
        required: "{field} can't be blank",
        invalid:  "{field} is invalid",
        success: "sucessfully submitted"
      },
      submitted: {
        title: 'Submitted',
        info: "The submitted contract information is under verification. The process will take a few minutes. If verified successfully, the contract will be shown in the Contracts list. If the verification failed and the contract is not shown, which means the submitted contract information does not exactly match the one deployed on the blockchain, please submit again with accurate information."
      },
      multiFileTip: `
        Currently only support for verification of files in the same directory.
      `,
    }
  },
  tokens: {
    list: {
      name: "Token List",
      tab: {
        hash: "Hash",
        name: "Name",
        time: "Created Time",
        txns: "Transactions",
        desc: "Description",
        logo: "Logo",
        symbol: "Symbol",
        creator: "Creator",
        totalSupply: "Total Supply",
        decimals: "Decimals",
        addressCount: "Holders",
        vm_category: "VM Category",
        address: "Address"
      },
      type: "{type} Tokens"
    },
    detail: {
      vm_category: "VM Category",
      name: "Token Detail Page",
      hash: "HASH",
      address: "Address",
      overview: "Contract Overview",
      desc: "Description",
      txOn: "Number Of Transactions In The Contract:",
      creator: "Creator",
      createdTime: "Created Time",
      contractInfo: "Info",
      logo: "Logo",
      ontFlow: "ONT Flow: ",
      ongFlow: "ONG Flow: ",
      amount: "Total Flow: ",
      txn: "Transactions",
      volume: "Volume",
      code: "ByteCode",
      abi: "ABI",
      totalSupply: "Total Supply",
      decimals: "Decimals",
      statistic: "Statistics",
      tokenLbl: "Token Label",
      tokenImg: "Token Image",
      holder: "Holders",
      tip:
        "Please note: Here is daily cumulative statistics, there is up to 10 minutes statistical difference.",
      price: "Price",
      tokenOverview: "Overview",
      tokenProfile: "Profile"
    },
    submit: {
      headline: "Submit Your Token Information",
      separator: " ",
      form: {
        hash: "Token Hash",
        name: "Token Name",
        VM: "Virtual Machine Category",
        ABI: "Token Abi",
        code: "Token Code",
        description: "Description",
        symbol: "Token Symbol",
        decimals: "Token Decimals",
        totalSupply: "Total Supply",
        logoTip: "256px*256px in jpg or png, no rounded corners",
        contactInformation: "Contact Information",
        website: "Website (Optional)",
        email: "E-mail",
        ID: "Token ID",
        operation: "Operation",
        noAdded: "No token added",
        add: "Add",
        succ: "Token information is sucessfully submitted"
      }
    }
  },
  statistics: {
    name: "History Statistics",
    day: " Day ",
    newAddressLbl: "New Address",
    activeAddressLbl: "Active Address",
    blockLbl: "New Block",
    newOntIdLbl: "New ONT ID",
    activeOntIdLbl: "Active ONT ID",
    sumAddressLbl: "Address Growth",
    sumOntIdLbl: "ONT ID Growth",
    txnLbl: "Transaction History",
    ontLbl: "ONT Amount",
    ongLbl: "ONG Amount"
  },
  footer: {
    flag: "en",
    Development: "Development",
    DeveloperCenter: "Developer Center",
    dApp: "dApps List",
    Tutorials: "Tutorials",
    Documentation: "Documentation",
    Bounty: "Bounty",
    SmartX: "SmartX",
    Github: "Github",
    Cooperation: "Cooperation",
    CooperateWithOntology: "Cooperate with Ontology",
    TrustEcosystem: "Trust Ecosystem",
    Nodes: "Nodes",
    About: "About",
    Press: "Press",
    TechNews: "Tech News",
    Team: "Team",
    AboutOntology: "About Ontology",
    WhitePaper: "White Paper",
    Explorer: "Explorer",
    dApps: "dApps",
    dAppsList: "dApps List",
    SubmitAdApp: "Submit a dApp"
  },
  form: {
    contractForm: "CONTRACT REGISTRATION FORM",
    name: "Project name",
    logo: "Project logo",
    description: "Project description",
    webLink: "Project official website and social media links",
    gitHubURL: "Project GitHub URL",
    ONTID: "ONT ID",
    contractHash: "Contract hash ",
    contractABI: "Contract ABI ",
    contractByteCode: "Contract ByteCode ",
    add: "Add",
    delete: "Delete",
    addFile: "Add File",
    required: "Required",
    requiredtext: "* Required",
    requiredstar: "*"
  },
  tooltip: {
    address: {
      ont: "ONT balance",
      ong: "ONG balance",
      unboundong:
        "Unbound ONG,You can convert all of them into Claimable ONG through one ONT transfer",
      claimableong:
        "Claimable ONG,You can withdraw it to the ONG balance with a single withdrawal operation",
      oep4:
        "The OEP-4 proposal is the standard interface for tokens, which allows the implementation of standard APIs for tokens in smart contracts. OEP-4 is a standardized token. ",
      oep5:
        "The OEP-5 proposal is the standard interface for NFT, which allows the implementation of standard APIs for tokens in smart contracts. NFT's standard token interface allows tokens on the ONT to be used by other applications.",
      oep8:
        "The OEP-8 proposal is the standard interface for Crypto Item, which allows you to transfer any number of tokens for differential encryption items from one address to another. It combines the advantages of OEP-4 and OEP-5 to make it easy to transfer different types of Crypto Item.",
      orc20: "",
      orc721: "",
      orc1155: ""
    },
    ontid: {
      Type:
        "Ontology supports multiple encryption algorithms, including ECDSA, SM2, and ED25519.",
      Curve:
        "Key curves, such as: P-224, P-256, P-384, P-521, sm2p256v1, SM3withSM2, 25519, SHA512withEdDSA",
      Value: "Publickey in HEX string",
      PublicKeyId: "Owner publickey"
    },
    block: {
      height: "Block height",
      time: "Created time of this block",
      size: "Size of this block, unit:bytes",
      hash: "Block hash",
      bookkeeper: "Keepers of this block",
      merkle: "The root of the Merkle tree for all transactions in this block",
      consensus: "Consensus data"
    },
    tx: {
      hash: "Transaction Hash",
      time: "Created time of the transaction",
      type:
        "Transaction type,include deploy smart contract,invoke neovm smart contract,invoke wasmvm smart contract",
      txhex:
        "The transaction serialized information, which is represented by a hexadecimal string",
      txjson:
        "The detailed information of the corresponding transaction which is represented by a JSON format string",
      scevent: "Contract event",
      height: "The height of the block where the transaction exists",
      fee: "Transaction Fees",
      status: "Transaction state on the blockchain",
      nonce:
        "Sequential running number for an address, beginning with 0 for the first transaction",
      from:
        "The sending party of the transaction (could be from a contract address)",
      to:
        "The receiving party of the transaction (could be a contract address)",
      inputData: "Additional information that is required for the transaction"
    },
    token: {
      hash: "Token Contract hash",
      creater: "Token Contract creator's address",
      createdTime: "Token Contract creation time",
      totalSupply: "Total supply of the token",
      decimals: "Decimals of the token",
      vm_category: "Virtual machine category",
      addressesamount:
        "The number of addresses that have a balance of this token.",
      txamount:
        "Please note: Here is daily cumulative statistics, there is up to 10 minutes statistical difference.",
      volume:
        "Please note: Here is daily cumulative statistics, there is up to 10 minutes statistical difference.",
      price: "Price per Token"
    },
    contract: {
      hash: "Contract hash",
      creater: "Contract creator's address",
      createdTime: "Contract creation time",
      addressesamount:
        "The number of addresses that have been involved in the transactions with this contract.",
      txamount:
        "Please note: Here is daily cumulative statistics, there is up to 10 minutes statistical difference.",
      volume:
        "Please note: Here is daily cumulative statistics, there is up to 10 minutes statistical difference.",
      toggleFullscreen: "Toggle Fullscreen",
      copySourceCode: "Copy to clipboard"
    }
  },
  user: {
    login: "Login",
    use: "Use ONTO APP scan QR code",
    download: "Download ONTO App",
    info: "User Info",
    basic: "Basic",
    address: "Address management",
    name: "Name: ",
    ontid: "ONT ID: ",
    email: "Email: ",
    create: "Created Time: ",
    last: "Last Login: "
  },
  error: {
    format: "Sorry, the search string you entered could not be found.",
    copied: "Copy successful",
    pagesize: "pageSize limit 20",
    searching: "Querying",
    msg1: "Please enter Token hash",
    msg2: "Please enter the token name",
    msg3: "Please enter Token Abi",
    msg4: "Please enter Token Code",
    msg5: "Please enter Token Description",
    msg6: "Please enter Token Symbol",
    msg7: "Please enter Token Decimals",
    msg8: "Please enter Token Total Supply",
    msg9: "Please upload Token Logo",
    msg10: "Please enter the email in the correct format",
    msg11: "Please enter the contact email address",
    msg12: "Please enter information for at least one token",
    msg13: "Please select a virtual machine category",
    msg14: "Please enter {type} Token ID",
    msg15: "Please enter {type} Token Name",
    msg16: "Please enter {type} Token Total Supply",
    msg17: "Please enter {type} Token Symbol",
    msg18: "{type} Token ID is duplicated",
    msg19: "The token hash you submitted could not be found",
    msg20: "The token has been submitted",
    msg21: "Token total supply range 1-999999999999999"
  },
  exportData: {
    h1: "Download Records of Transactions",
    h2:
      "The records of transactions can be downloaded from this page. Before continuing please complete the captcha below to verify that you are a human.",
    tips: "Download the earliest 5000 records starting from",
    timeout: "To avoid timeouts, please select a small date range",
    download: "Download",
    to: "To",
    succ: "Download successful!"
  },
  ...enLocale
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js